import axios from "axios";
//http client
import configData from "./../configData";
import { tokenConfig } from "./authActions";
import {
  ADD_BASELINE,
  ADD_FOLDER,
  ADD_ITEM,
  BASELINE_NOTIFICATION,
  COPY_TASKS,
  DELETE_ITEM,
  DELETE_LOCAL_ITEMS,
  DELETE_OLD_ITEMS,
  GET_BASELINE,
  GET_ITEM,
  GET_ITEMLIST,
  GET_ITEMS,
  ITEMS_LOADING,
  ITEM_ERROR,
  ITEM_NOTIFICATION,
  LOGOUT_SUCCESS,
  UPDATE_FOLDER,
  UPDATE_ITEM,
  ITEM_COOLDOWN,
  ITEM_BACKUP,
  ITEM_UPDATE_PERCENTAGE,
} from "./types";
// import { returnErrors } from "./errorActions";
// import { bindActionCreators } from "redux";

export const changeItemCoolDown = (itemCoolDown) => (dispatch) => {
  dispatch({ type: ITEM_COOLDOWN, payload: itemCoolDown });
  setTimeout(() => {
    dispatch({
      type: ITEM_COOLDOWN,
      payload: {
        id: null,
      },
    });
  }, 5000);
};

function getItemsAction(info, failCnt, dispatch, getState) {
  if (failCnt === undefined) {
    failCnt = 3;
  }
  // dispatch for redux thunk
  if (failCnt > 0) {
    axios
      .post(`${configData.SERVER_URL}items`, info, tokenConfig(getState))
      .then((res) =>
        // axios will prevent us from doing httpRequest..
        //https://github.com/axios/axios

        {
          let items = res.data.resarr;
          let folder = res.data.folderArr;
          // if (info.hasOwnProperty("lockedBy")) {
          //   let fIt = items.findInd((x) => x._id === info.itemID);
          //   if (fIt > -1) {
          //     items[fIt].lockedBy = "";
          //   }
          // }
          dispatch({
            type: UPDATE_FOLDER,
            payload: folder,
            // sending data as payload to reducer
          });
          dispatch({
            type: GET_ITEMS,
            payload: items,
            // sending data as payload to reducer
          });
          dispatch({
            type: ITEM_NOTIFICATION,
            payload: "Worksheets loaded.",
          });
          setTimeout(() => {
            dispatch({
              type: ITEM_NOTIFICATION,
              payload: "",
            });
          }, 2000);
        }
      )
      .catch((error) => {
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);

          console.log(error.response.status);
          console.log(error.response.headers);
          if (error.response.data)
            if (error.response.data.res)
              if (
                error.response.data.res.includes("err token or user undefined")
              )
                dispatch({
                  type: LOGOUT_SUCCESS,
                });
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
          setTimeout(() => {
            getItemsAction(info, failCnt - 1, dispatch, getState);
          }, 8000);
        } else {
          console.log("getItems problme");
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
      });
  }
}

export const getItems = (info, failCnt) => (dispatch, getState) => {
  if (failCnt === undefined) {
    failCnt = 3;
  }
  // dispatch for redux thunk
  if (failCnt > 0) {
    dispatch({
      type: DELETE_OLD_ITEMS,
    });

    dispatch({
      type: ITEM_NOTIFICATION,
      payload: "Worksheets loading...",
    });
    setTimeout(() => {
      dispatch({
        type: ITEM_NOTIFICATION,
        payload: "",
      });
    }, 5000);
    // console.log("getItems action");

    getItemsAction(info, failCnt - 1, dispatch, getState);
  }
};
//request to backend

//we need to implement an unlock action otherwise server will provide outdated information
// export const unlockItem = (info) => (dispatch, getState) => {
//   // setTimeout(() => {
//   dispatch({
//     type: ITEM_UNLOCK,
//     payload: info,
//   });
//   // }, 000);
// };
function getItemAction(info, failCnt, dispatch, getState) {
  if (failCnt > 0) {
    console.log("fialtcnnttdfs", failCnt);

    axios
      .post(`${configData.SERVER_URL}items`, info, tokenConfig(getState))
      .then((res) => {
        if (info.hasOwnProperty("getItemList")) {
          dispatch({
            type: GET_ITEMLIST,
            payload: res.data,
          });
          dispatch({
            type: ITEM_NOTIFICATION,
            payload: "",
          });
        } else {
          dispatch({
            type: GET_ITEM,
            payload: res.data,
          });
          // dispatch({
          //   type: ITEM_NOTIFICATION,
          //   payload: "",
          // });
        }
        // setTimeout(() => {
        //   dispatch({
        //     type: ITEM_NOTIFICATION,
        //     payload: "",
        //   });
        // }, 2000);
      })
      .catch((error) => {
        // if (err.response === undefined)
        //   dispatch({
        //     type: LOGOUT_SUCCESS,
        //   });
        // else
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          // dispatch({
          //   type: PROJ_ERROR,
          //   payload: error.response.data.res,
          // });
          // setTimeout(() => {
          //   dispatch({
          //     type: PROJ_ERROR,
          //     payload: "",
          //   });
          // }, 5000);
          console.log(error.response.status);
          console.log(error.response.headers);
          if (error.response.data)
            if (error.response.data.res)
              if (
                error.response.data.res.includes("err token or user undefined")
              ) {
                console.log("error", error.response);
                dispatch({
                  type: LOGOUT_SUCCESS,
                });
              }
        } else if (error.request) {
          // The request was made but no response was received
          setTimeout(() => {
            if (failCnt === undefined || failCnt === "") {
              failCnt = 3;
            }
            getItemAction(info, failCnt - 1, dispatch, getState);
          }, 8000);
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
      });
  }
}

export const getItem = (info) => (dispatch, getState) => {
  dispatch({
    type: ITEM_NOTIFICATION,
    payload: "Data loading...",
  });
  setTimeout(() => {
    dispatch({
      type: ITEM_NOTIFICATION,
      payload: "",
    });
  }, 10000);

  getItemAction(info, 3, dispatch, getState);
  // let itemIni = { item: {} };
  // dispatch({
  //   type: GET_ITEM,
  //   payload: itemIni,
  // });
};

export const addBaseline = (info) => (dispatch, getState) => {
  if (info.hasOwnProperty("addBaseline")) {
    dispatch({
      type: BASELINE_NOTIFICATION,
      payload: "Creating baseline...",
    });
  } else {
    dispatch({
      type: BASELINE_NOTIFICATION,
      payload: "Deleting baseline...",
    });
  }
  setTimeout(() => {
    dispatch({
      type: BASELINE_NOTIFICATION,
      payload: "",
    });
  }, 12000);
  // let itemIni = { item: {} };
  // dispatch({
  //   type: GET_ITEM,
  //   payload: itemIni,
  // });
  axios
    .post(`${configData.SERVER_URL}baseline`, info, tokenConfig(getState))
    .then((res) => {
      dispatch({
        type: ADD_BASELINE,
        payload: {
          data: res.data,
          itemID: info._id,
          requestType: info.addBaseline ? true : false,
        },
      });
    })
    .catch((error) => {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        if (error.response.data)
          if (error.response.data.res)
            if (
              error.response.data.res.includes("err token or user undefined")
            ) {
              console.log("error", error.response);
              dispatch({
                type: LOGOUT_SUCCESS,
              });
            }
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    });
};

export const getBaseline = (info) => (dispatch, getState) => {
  dispatch({
    type: ITEM_NOTIFICATION,
    payload: "Get baseline...",
  });
  setTimeout(() => {
    dispatch({
      type: ITEM_NOTIFICATION,
      payload: "",
    });
  }, 10000);
  // let itemIni = { item: {} };
  // dispatch({
  //   type: GET_ITEM,
  //   payload: itemIni,
  // });
  axios
    .post(`${configData.SERVER_URL}baselineDic`, info, tokenConfig(getState))
    .then((res) => {
      dispatch({
        type: GET_BASELINE,
        payload: { data: res.data, itemID: info._id },
      });
    })
    .catch((error) => {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        if (error.response.data)
          if (error.response.data.res)
            if (
              error.response.data.res.includes("err token or user undefined")
            ) {
              console.log("error", error.response);
              dispatch({
                type: LOGOUT_SUCCESS,
              });
            }
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    });
};

// export const getCardItems = (info) => (dispatch, getState) => {
//   console.log("getCardItems action ", info);
//   axios
//     .post(
//       "${configData.SERVER_URL}items",
//       info,
//       tokenConfig(getState)
//     )
//     .then((res) => {
//       console.log("prob1", res);
//       dispatch({
//         type: GET_CARDITEMS,
//         payload: res.data,
//       });
//       console.log("prob2");
//     })
//     .catch((error) => {
//       if (error.response) {
//         // Request made and server responded
//         console.log(error.response.data);
//         // dispatch({
//         //   type: PROJ_ERROR,
//         //   payload: error.response.data.res,
//         // });
//         // setTimeout(() => {
//         //   dispatch({
//         //     type: PROJ_ERROR,
//         //     payload: "",
//         //   });
//         // }, 5000);
//         console.log(error.response.status);
//         console.log(error.response.headers);
// if (error.response.data.res.includes("err token or user undefined"))
//   dispatch({
//     type: LOGOUT_SUCCESS,
//   });
//       } else if (error.request) {
//         // The request was made but no response was received
//         console.log(error.request);
//       } else {
//         // Something happened in setting up the request that triggered an Error
//         console.log("Error", error.message);
//       }
//     });
// };

export const addItem = (item) => (dispatch, getState) => {
  dispatch({
    type: ITEM_NOTIFICATION,
    payload: "Data loading...",
  });
  setTimeout(() => {
    dispatch({
      type: ITEM_NOTIFICATION,
      payload: "",
    });
  }, 10000);
  axios
    .post(`${configData.SERVER_URL}items`, item, tokenConfig(getState))
    .then((res) => {
      dispatch({
        type: ADD_ITEM,
        payload: res.data,
      });
      dispatch({
        type: ITEM_NOTIFICATION,
        payload: "",
      });
    })
    .catch((error) => {
      if (error.response) {
        // Request made and server responded
        console.log(error.response.data);
        // dispatch({
        //   type: PROJ_ERROR,
        //   payload: error.response.data.res,
        // });
        // setTimeout(() => {
        //   dispatch({
        //     type: PROJ_ERROR,
        //     payload: "",
        //   });
        // }, 5000);
        console.log(error.response.status);
        console.log(error.response.headers);
        if (error.response.data)
          if (error.response.data.res)
            if (
              error.response.data.res.includes("err token or user undefined")
            ) {
              console.log("error", error.response);
              dispatch({
                type: LOGOUT_SUCCESS,
              });
            }
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    });
};

function updateItemAct(item, failCnt, dispatch, getState) {
  if (failCnt === undefined) {
    failCnt = 3;
  }
  console.log("updateItemAct");
  axios
    .post(
      `${configData.SERVER_URL}items/${item._id}`,
      item,
      tokenConfig(getState)
    )
    .then((res) => {
      dispatch({
        type: UPDATE_ITEM,
        payload: res.data,
      });
      dispatch({
        type: ITEM_NOTIFICATION,
        payload: "Saved.",
      });
      setTimeout(() => {
        dispatch({
          type: ITEM_NOTIFICATION,
          payload: "",
        });
      }, 5000);
    })
    .catch((error) => {
      if (error.response) {
        // Request made and server responded
        console.log(error.response.data);
        // dispatch({
        //   type: PROJ_ERROR,
        //   payload: error.response.data.res,
        // });
        // setTimeout(() => {
        //   dispatch({
        //     type: PROJ_ERROR,
        //     payload: "",
        //   });
        // }, 5000);
        console.log(error.response.status);
        console.log(error.response.headers);
        if (error.response.data)
          if (error.response.data.res)
            if (
              error.response.data.res.includes("err token or user undefined")
            ) {
              console.log("error", error.response);
              dispatch({
                type: LOGOUT_SUCCESS,
              });
            }
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);

        // setTimeout(() => {
        //   console.log("getItems call again");
        // updateItemAct(item, failCnt - 1, dispatch, getState);
        // }, 8000);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
      // dispatch(returnErrors(err.response.data, err.response.status));
    });
}

export const updateItem = (item) => (dispatch, getState) => {
  dispatch({
    type: ITEM_NOTIFICATION,
    payload: "Loading...",
  });
  setTimeout(() => {
    dispatch({
      type: ITEM_NOTIFICATION,
      payload: "",
    });
  }, 15000);

  updateItemAct(item, 1, dispatch, getState);
};
export const updateItemView = (info) => (dispatch, getState) => {
  dispatch({
    type: ITEM_UPDATE_PERCENTAGE,
    payload: info,
  });
};

async function modifyWorksheetInfoAct(item, backupNumber, dispatch, getState) {
  console.log("getstta", getState());
  const backup = getState().item.backup || {};
  console.log("backupp", backup);
  for (const [keyy, value] of Object.entries(backup)) {
    console.log("POROBLEM", typeof keyy, typeof backupNumber);
    if (keyy !== backupNumber.toString())
      if (parseInt(keyy) + 5 * 60 * 1000 > new Date().getTime()) {
        try {
          const response = await axios.post(
            `${configData.SERVER_URL}worksheet/${value.itemID}`,
            value,
            tokenConfig(getState)
          );
          console.log("ttestst", response.status, response.data);
          if (response.status === 200 || response.data) {
            console.log("dispatch ", keyy);
            dispatch({
              type: UPDATE_ITEM,
              payload: {
                ...response.data,
                backupNumber: keyy,
                deleteBackup: true,
              },
            });

            continue;
          } else {
            console.error(
              `Non-200 status for item: ${value}, status: ${response.status}`
            );
            break;
          }
        } catch (error) {
          console.error(`Error for item: ${value}`, error.message);
          break;
        }
      } else {
        dispatch({
          type: UPDATE_ITEM,
          payload: { backupNumber: keyy, deleteBackup: true },
        });
      }
  }
  console.log("AXIOS REQ", backupNumber);
  axios
    .post(
      `${configData.SERVER_URL}worksheet/${item.itemID}`,
      item,
      tokenConfig(getState)
    )
    .then((res) => {
      console.log("reessgrg", res);
      if (res == 200 || res.data) {
        dispatch({
          type: UPDATE_ITEM,
          payload: { ...res.data, backupNumber, deleteBackup: true },
        });
        console.log("AXIOS REQ ANSW", backupNumber);
        dispatch({
          type: ITEM_NOTIFICATION,
          payload: "Saved.",
        });
        setTimeout(() => {
          dispatch({
            type: ITEM_NOTIFICATION,
            payload: "",
          });
        }, 5000);
      }
    })
    .catch((error) => {
      dispatch({
        type: ITEM_NOTIFICATION,
        payload: "ERROR save data",
      });
      if (error.response) {
        dispatch({
          type: ITEM_ERROR,
          payload: true,
        });
        setTimeout(() => {
          dispatch({
            type: ITEM_ERROR,
            payload: false,
          });
        }, 1000);
        if (error.response.data)
          if (error.response.data.res)
            if (
              error.response.data.res.includes("err token or user undefined")
            ) {
              console.log("error", error.response);
              dispatch({
                type: LOGOUT_SUCCESS,
              });
            }
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);

        // setTimeout(() => {
        //   console.log("getItems call again");
        //   updateItemAct(item, failCnt - 1, dispatch, getState);
        // }, 8000);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
      // dispatch(returnErrors(err.response.data, err.response.status));
    });
}

export const modifyWorksheetInfo = (item) => (dispatch, getState) => {
  dispatch({
    type: ITEM_NOTIFICATION,
    payload: "Loading...",
  });
  let backupNumber = new Date().getTime();

  // if(item.backupNumber)

  // gerer le loading afficher text à utilisateur
  // si jamais offline on doit mettre modifications dans cache avec identifiant
  // sur serveur on sauvegarde identifiant pour savoir si modification a ete pris en compte
  // if (item.forceBecauseOfUnmount) {
  // setTimeout(() => {
  console.log("ADD BACKUP AXIOS BEFORE _____");

  item = { ...item, backupNumber };
  dispatch({
    type: ITEM_BACKUP, // avoid taking backup directly into account
    payload: { item, backupNumber, addBackup: true },
  });
  // }, 200);
  // }
  setTimeout(() => {
    dispatch({
      type: ITEM_NOTIFICATION,
      payload: "",
    });
  }, 15000);

  modifyWorksheetInfoAct(item, backupNumber, dispatch, getState);
};

export const updateItemFromWS = (item) => (dispatch, getState) => {
  dispatch({
    type: UPDATE_ITEM,
    payload: item,
  });
};

export const deleteItem = (info) => (dispatch, getState) => {
  var varToken = tokenConfig(getState);
  varToken = varToken.headers;
  // console.log("vartoken", varToken);
  var dataObj = { headers: varToken, data: { projectID: info.projectID } };

  dispatch({
    type: ITEM_NOTIFICATION,
    payload: "Data loading...",
  });
  setTimeout(() => {
    dispatch({
      type: ITEM_NOTIFICATION,
      payload: "",
    });
  }, 10000);

  // console.log("token", tokenConfig(getState));
  axios
    .delete(`${configData.SERVER_URL}items/${info._id}`, dataObj)
    .then((res) => {
      // attention to back ticks!!!
      // console.log("delete resp", res);
      dispatch({
        type: DELETE_ITEM,
        payload: info._id,
      });
      // dispatch({
      //   type: ITEM_NOTIFICATION,
      //   payload: "Saved.",
      // });
      // setTimeout(() => {
      dispatch({
        type: ITEM_NOTIFICATION,
        payload: "",
      });
      // }, 5000);
    })
    .catch((error) => {
      if (error.response) {
        // Request made and server responded
        console.log(error.response.data);

        console.log(error.response.status);
        console.log(error.response.headers);
        if (error.response.data)
          if (error.response.data.res)
            if (
              error.response.data.res.includes("err token or user undefined")
            ) {
              console.log("error", error.response);
              dispatch({
                type: LOGOUT_SUCCESS,
              });
            }
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    });
};

export const setItemsLoading = () => {
  return {
    type: ITEMS_LOADING,
    payload: true,
  };
};

export const setItemsNotLoading = () => {
  return {
    type: ITEMS_LOADING,
    payload: false,
  };
};

// before using database, itemAction returns to
// reducer type of action with information
// after: itemAction sets directly in database
// variables or gets items from database and
// dispatch action

//before: itemAction -> reducer
//after: itemAction -> database -> itemAction -> reducer

export const copyTasks = (info) => (dispatch, getState) => {
  dispatch({
    type: COPY_TASKS,
    payload: info,
  });
};

export const deleteLocalSavedItems = (info) => (dispatch, getState) => {
  dispatch({
    type: DELETE_LOCAL_ITEMS,
    payload: info,
  });
};
